import * as React from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

const ErrorPage = () => {
  const error = useRouteError();

  if (isRouteErrorResponse(error) && error.status === 404) {
    return (
      <div className="text-center p-8 flex w-full h-full justify-center items-center flex-col">
        <h1 className="text-4xl font-semibold mb-4">404</h1>
        <p>Siden, du ledte efter, eksistere ikke.</p>
      </div>
    );
  }

  return (
    <div className="text-center p-8 flex w-full h-full justify-center items-center flex-col">
      <h1 className="text-4xl font-semibold mb-4">Hov!</h1>
      <p>Der opstod en uventet fejl.</p>

      <pre className="bg-gray-100 p-4 px-5 rounded-lg mt-8">
        {error instanceof Error && (
          <>
            {error.message
              ? <p className="text-red-500">{error.message}</p>
              : null}

          </>
        )}
      </pre>
    </div>
  );
};

export default ErrorPage;
